// extracted by mini-css-extract-plugin
module.exports = {"LocaleSwitcher":"intl_LocaleSwitcher__8HMjH","Link":"intl_Link__hpE21 undefined Button_Primary__Pl5nL Button_Common__946GX"};